import { createContext } from 'react';

const FeedbackContext = createContext();

export default FeedbackContext;
